// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"btnWrapper___5TUO4","icon":"icon___335J-","title":"title___2i1Xy"};